module.exports = __webpack_public_path__ + "img/途牛_02.ad42f030.jpg";